import React from "react";
import ReactDOM from "react-dom";
import {PrimaryButton} from "@sfly/uig-button";

import PropTypes from "prop-types";


let modalRoot = document.getElementById("modal-root");

export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement("div");
        this.state = {
            name: props.children,
            done: false
        };
        this._input;
    }

    componentWillMount() {
    }

    onClose = e => {
        // document.getElementsByTagName('body')[0].style.background = 'white';
        console.log("BUTTON CLICKED");
        e.stopPropagation();
        this.setState({done: false})
        this.props.onClose && this.props.onClose(e);
    };

    onSave = e => {
        const {name} = this.state;
        //this.props.saveProject();

        e.stopPropagation();
        this.props.onClose && this.props.onClose(e);
        this.props.saveProject(name);
    };

    onChange = event => {
        var name = event.target.value;
        this.setState({
            name
        });
    };

    onKeyUp = e => {
        // Lookout for ESC key (27)
        if (e.which === 27 && this.props.show) {
            this.onClose(e);
        }
    };

    componentDidMount() {
        document.addEventListener("keyup", this.onKeyUp);
        if (modalRoot) {
            modalRoot.appendChild(this.el);
        } else {
            modalRoot = document.createElement("div");
            modalRoot.appendChild(this.el);
            document.getElementsByTagName("body")[0] &&
            document.getElementsByTagName("body")[0].appendChild(modalRoot);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.onKeyUp);
        if (modalRoot) {
            modalRoot.removeChild(this.el);
        }
    }

    componentDidUpdate = () => {
        if (!this.state.done) {

            this._input && this._input.focus();

        }
    }


    render() {
        var modalUI = (
            <div className="modal-share-save">
                <div className="modal-share-header inline-wrapper">
                    <div
                        key="close"
                        className="sfly-share-header-close inline-div-one"
                        onClick={this.onClose}
                    />
                    <h3 className="margin-bottom-none inline-div-two">Save Project</h3>
                </div>
                <div className="modal-share-content">
                    <div className="form-section">
                        <label className="share-pull-left">Project name:</label>
                        <br/>
                        <input
                            className="share-input-text"
                            type="text"
                            onChange={this.onChange}
                            defaultValue={this.props.children}
                            className="form-field share-pull-left"
                            name="name"
                            placeholder={this.props.children}
                            ref={c => (this._input = c)}
                        />
                    </div>
                </div>
                <div className="modal-share-footer">
                    <div className="button-wrapper">
                        <div className="button-save">
                            {
                                this.state.done || !this.props.checkIfMobileDevice() ?
                                    <PrimaryButton
                                        onClick={e => {
                                            this.onSave(e);
                                        }}
                                    >
                                        save
                                    </PrimaryButton>
                                    :
                                    <PrimaryButton
                                        onClick={e => {
                                            this.setState({done: true})
                                        }}>
                                        Done
                                    </PrimaryButton>
                            }

                        </div>

                    </div>
                </div>
            </div>
        );
        if (!this.props.show) {
            return null;
        }
        return ReactDOM.createPortal(modalUI, this.el);
    }
}

Modal.propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired
};
